import type { SxProps, Theme } from '@mui/material/styles';
interface SharedDataGridThemeOptions {
  toolbarQuickFilterWidth?: number | string;
  sx?: SxProps<Theme>;
}

export function getSharedDataGridTheme(
  theme: Theme,
  { toolbarQuickFilterWidth = 300, sx }: SharedDataGridThemeOptions = {}
): SxProps<Theme> {
  return {
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
    },
    '& .MuiDataGrid-scrollShadow': {
      display: 'none !important',
    },
    '& .MuiDataGrid-toolbar .MuiTextField-root': {
      width: toolbarQuickFilterWidth,
    },
    '& .MuiDataGrid-cell': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.semantic.outline.dark
          : undefined,
    },
    '& .MuiCheckbox-root': {
      '&.Mui-checked': {
        color:
          theme.palette.mode === 'dark'
            ? theme.palette.colors.info[400]
            : undefined,
      },
      '&.MuiCheckbox-indeterminate': {
        color:
          theme.palette.mode === 'dark'
            ? theme.palette.colors.info[400]
            : undefined,
      },
    },
    '& .MuiDataGrid-columnHeaders ': {
      color: theme.palette.semantic.text.heading,
    },
    '& .MuiDataGrid-topContainer .MuiDataGrid-columnHeaders div div': {
      background: theme.palette.semantic.surface.bg2,
    },
    '& .MuiDataGrid-detailPanel': {
      background: theme.palette.background.default,
    },
    '& .MuiDataGrid-columnHeader .MuiDataGrid-sortButton': {
      background: 'inherit',
      '&:hover': {
        background:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.background.default,
      },
    },
    '& .MuiDataGrid-scrollbar--horizontal': {
      overflow: 'hidden',
    },
    '& .MuiDataGrid-toolbar': {
      minHeight: 'unset',
      padding: '8px',
    },
    ...sx,
  };
}

export function getSharedDataGridFilterTheme(sx?: SxProps): SxProps {
  return {
    ...sx,
    '& .MuiDataGrid-filterForm': {
      display: 'flex',
      gap: 1,
      alignItems: 'flex-end',
    },
    '& .MuiDataGrid-panelContent': {
      padding: '8px',
    },
    '& .MuiDataGrid-panelFooter': {
      padding: '4px',
      borderTop: 'unset',
    },
    '& .MuiInputLabel-root': {
      transform: 'translate(0px, 8px) scale(1)',
      transformOrigin: 'top left',
    },
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      transform: 'translate(0px, -4px) scale(0.75)',
    },
    '& .MuiDataGrid-filterFormValueInput .MuiBox-root': {
      top: 0,
    },
  };
}
